// extracted by mini-css-extract-plugin
export var favicon = "Header-module--favicon--XOoR0";
export var header = "Header-module--header--3ERvK";
export var navButton = "Header-module--navButton--UEVi2";